<template>
    <select class="form-control" v-model="changedValue">
        <option value="Waiting for approval" :disabled="['Accept to Pick Up','Picked Up','Shipping','Shipped','Out For Delivery','Cancle','Return Request','Returned','Delivered'].includes(changedValue)">Pending Approval</option>
        <option value="Vendor Approved" :disabled="['Accept to Pick Up','Picked Up','Shipping','Shipped','Out For Delivery','Cancle','Return Request','Returned','Delivered'].includes(changedValue)">Approved</option>
        <option value="Decline" :disabled="['Accept to Pick Up','Picked Up','Shipping','Shipped','Out For Delivery','Cancle','Return Request','Returned','Delivered'].includes(changedValue)">Not Approved</option>
        <option value="In Progress" :disabled="['Accept to Pick Up','Picked Up','Shipping','Shipped','Out For Delivery','Cancle','Return Request','Returned','Delivered'].includes(changedValue)">In Progress</option>
        <option value="Ready to Pick Up" :disabled="['Accept to Pick Up','Picked Up','Shipping','Shipped','Out For Delivery','Cancle','Return Request','Returned','Delivered'].includes(changedValue)">Ready for Pick Up</option>

        <option value="Accept to Pick Up" :disabled="['Picked Up','Shipping','Shipped','Out For Delivery','Cancle','Return Request','Returned','Delivered'].includes(changedValue) || user.type!='Admin'">Accept to Pick Up</option>

        <option value="Picked Up" :disabled="user.type!='Admin'">Picked Up</option>
        <option value="Shipping" :disabled="user.type!='Admin'">Shipping</option>
        <option value="Shipped" :disabled="user.type!='Admin'">Shipped</option>
        <option value="Out For Delivery" :disabled="user.type!='Admin'">Out For Delivery</option>
        <option value="Cancle" :disabled="user.type!='Admin'">Cancle</option>
        <option value="Return Request" :disabled="user.type!='Admin'">Return Request</option>
        <option value="Returned" :disabled="user.type!='Admin'">Returned</option>
        <option value="Delivered" :disabled="user.type!='Admin'">Delivered</option>
    </select>
</template>
<script>
 import {
     mapGetters,
     mapActions
 } from "vuex";
 export default {
     inject: ['$validator'],
     name: 'OrderStatus',
     props: {
         selectedValue: {
             default: ''
         }
     },
     data() {
         return {
             changedValue: this.selectedValue,
         }
     },
     watch: {
         async selectedValue(n){
            this.changedValue=n
         },
         async changedValue(n){
             if (n && n!=this.selectedValue) {
                 this.$emit('statusChanged', n)
             }
         }
     },
     computed: {
         ...mapGetters("auth", ["user"]),
     },
     methods: {
     }
 };
</script>
